<template>
	<div>
		<Layout :navFixed="true" :transparent="true" :background="require('@/assets/img/bg-products.jpg')">
			<div class="container bg-white">
				<div class="">
					
				</div>
				<div class="filters-bar">
					<h1 class="page-title">
						Anafes, Hornos y Parrillas
					</h1>
					<div class="filters">
						<div class="btn" v-b-modal.modalFilterOrder>
							<svg class="ui-search-icon" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
								<path
									d="M6.857 23.527l-3.705-3.705-1.616 1.616 6.464 6.464 6.464-6.462-1.616-1.616-3.705 3.701v-18.953h-2.286v18.955zM22.857 8.473l-3.705 3.705-1.616-1.616 6.464-6.464 0.809 0.807 5.655 5.657-1.616 1.616-3.705-3.703v18.953h-2.286v-18.955z"
								></path>
							</svg>
							Ordenar
						</div>
						<div class="btn only-mobile" v-b-modal.modalFilterCategory>
							<svg class="ui-search-icon" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
								<path
									d="M15.9 22h16.1v2h-16.1c-0.479 2.301-2.491 4.005-4.9 4.005s-4.42-1.704-4.894-3.973l-0.006-0.032h-6.1v-2h6.1c0.479-2.301 2.491-4.005 4.9-4.005s4.421 1.704 4.894 3.973l0.006 0.032zM18.1 8c0.48-2.301 2.491-4.005 4.9-4.005s4.421 1.704 4.894 3.973l0.006 0.032h4.1v2h-4.1c-0.48 2.301-2.491 4.005-4.9 4.005s-4.421-1.704-4.894-3.973l-0.006-0.033h-18.1v-2h18.1zM23 12c1.657 0 3-1.343 3-3s-1.343-3-3-3v0c-1.657 0-3 1.343-3 3s1.343 3 3 3v0zM11 26c1.657 0 3-1.343 3-3s-1.343-3-3-3v0c-1.657 0-3 1.343-3 3s1.343 3 3 3v0z"
								></path>
							</svg>
							Filtrar
						</div>
						
						<div class="btn only-mobile" v-b-modal.modalSearch>
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
								<path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
							</svg>
							Buscar
						</div>
						<div class="only-desktop">
							<SearchBar :filters="filters"/>
						</div>
					</div>
				</div>

				<div class="row row-xs">
					<div class="col-12 mt-2">
						<div class="product-list">

							<div class="sidebar only-desktop">
								<h4 class="mb-3 mt-2">Categorías</h4>
								<div class="filter-list">
									<router-link v-for="category in categories" :key="category.id" tag="a" :to="`/productos/${category.slug}`" class="filter" :class="{ selected: categorySelected && category.id == categorySelected.id }">
										{{ category.title }}
									</router-link>
								</div>
							</div>

							<div class="content">


								<div class="row row-xs">
									<div class="col-12 mt-5 mb-5 p-5 text-center" v-if="!loading && items.length == 0">
										No se han encontrado productos que conicidan con su búsqueda
									</div>
									<div class="col-12">
										<div class="products-grid">
											<div v-for="item in items" :key="item.id">
												<ProductItem :item="item" />
											</div>
										</div>
									</div>
									
								</div>
								<div class="pagination-bar">
									<Pagination :pageData="pagination" @pageChange="pageChange" @pageLength="pageLength" />
								</div>
							</div>
						</div>
						<div class="mt-5 pt-5 p-4">
							<FoodTruckBanner />
						</div>
					</div>
				</div>
			</div>
		</Layout>

		<b-modal id="modalFilterCategory" hide-header hide-footer dialog-class="modal-fullscreen" scrollable centered>
			<div class="d-flex align-items-center pt-3 pb-3">
				<div @click="$bvModal.hide('modalFilterCategory')">
					<i class="icon icon-chevron-left mr-2"></i>
				</div>
				<h3 class="">Filtrar por categoría</h3>
			</div>
			<div class="filter-list">
				<router-link v-for="category in categories" :key="category.id" tag="a" :to="`/productos/${category.slug}`" class="filter" :class="{ selected: categorySelected && category.id == categorySelected.id }">
					{{ category.title }}
				</router-link>
			</div>
		</b-modal>

		<b-modal id="modalFilterOrder" hide-header hide-footer dialog-class="modal-fullscreen" scrollable centered>
			<div class="d-flex align-items-center pt-3 pb-3">
				<div @click="$bvModal.hide('modalFilterOrder')">
					<i class="icon icon-chevron-left mr-2"></i>
				</div>
				<h3 class="">Ordenar por</h3>
			</div>
			<div class="filter-list">
				<div
					class="filter"
					@click="
						filters.orderBy = 'PRICE_ASC'
						updateFilters()
					"
					:class="{ selected: filters.orderBy == 'PRICE_ASC' }"
				>
					Menor precio
				</div>
				<div
					class="filter"
					@click="
						filters.orderBy = 'PRICE_DESC'
						updateFilters()
					"
					:class="{ selected: filters.orderBy == 'PRICE_DESC' }"
				>
					Mayor precio
				</div>
			</div>
		</b-modal>
		
		<b-modal id="modalSearch" hide-header hide-footer dialog-class="modal-fullscreen" scrollable centered>
			<div class="d-flex align-items-center pt-3 pb-3">
				<div @click="$bvModal.hide('modalSearch')">
					<i class="icon icon-chevron-left mr-2"></i>
				</div>
				<h3 class="">Buscar</h3>
			</div>
			<div class="p-3">
				<SearchBar :filters="filters"/>
			</div>
			
		</b-modal>
	</div>
</template>

<script>
import gql from 'graphql-tag'
import ecommerceMixins from '@/components/ecommerce/mixins'
import listMixins from '@/components/ecommerce/listMixins'
import Layout from '@/components/Layout'
import ProductItem from '@/components/ProductItem'
import FoodTruckBanner from '@/components/FoodTruckBanner'
import SearchBar from '@/components/ecommerce/SearchBar'
import Pagination from '@/components/Pagination'

export default {
	name: 'Products',
	mixims: [ecommerceMixins, listMixins],
	components: {
		Layout,
		ProductItem,
		FoodTruckBanner,
		SearchBar,
		Pagination
	},
	metaInfo() {
		return {
			title: this.categorySelected ? this.categorySelected.title : 'Accesorios',
		}
	},
	data() {
		return {
			loading: true,
			categories: [],
			categorySelected: null,
			items: [],
			filters: null,
		}
	},
	async beforeMount() {
		this.filters = this.getValidUrlParams()
		await this.fetchData()
		
		this.load()
		if (this.$route.params.category) this.categorySelected = this.categories.find((c) => c.slug == this.$route.params.category)
		
	},
	methods: {
		load() {
			console.log(this.pagination)
			return this.$apollo
				.query({
					query: gql`
						query($status: String, $search: String $salable: Boolean, $category: String, $orderBy: String, $take:Int, $skip:Int) {
							products(status: $status, search: $search, salable: $salable, category: $category, orderBy: $orderBy, take: $take, skip:$skip) {
								data {
									id
									name
									slug
									salable
									price
									image {
										id
										type
										filename
										url
										urlThumb
									}
									featured
								}
								pageInfo {
									totalItems
								}
							}
						}
					`,
					variables: {
						status: 'ACTIVE',
						salable: true,
						category: this.$route.params.category ? this.$route.params.category : null,
						orderBy: this.filters.orderBy,
						search: this.filters.q,
						take: this.pagination.length,
						skip: this.pagination.skip,
					},
					fetchPolicy: 'network-only',
				})
				.then(({ data }) => {
					this.items = data.products.data
					this.pagination.pageInfo = data.products.pageInfo
					this.loading = false
				})
				.catch(() => {
					this.loading = false
				})
		},

		fetchData() {
			return this.$apollo
				.query({
					query: gql`
						query($status: String) {
							categories(status: $status) {
								data {
									id
									title
									slug
									status
								}
							}
						}
					`,
					variables: {
						status: 'ACTIVE',
					},
					fetchPolicy: 'network-only',
				})
				.then(({ data }) => {
					this.categories = data.categories.data
				})
				.catch((err) => {
					console.log(err)
				})
		},
	},
}
</script>

<style scoped lang="scss">

.product-list {
	display: flex;
}
.product-list .sidebar {
	flex-grow: 0;
	flex-shrink: 0;
	width: 240px;
	padding: 12px;
}
.product-list .content {
	flex-grow: 1;
}
.products-grid{
	display: grid;
	gap: 1rem;
}
@media (min-width: 520px) {
	.products-grid { 
		grid-template-columns: repeat(2, 1fr); 
	}
}
@media (min-width: 728px) {
	.products-grid { 
		grid-template-columns: repeat(1, 1fr); 
	}
}
@media (min-width: 860px) {
	.products-grid { 
		grid-template-columns: repeat(2, 1fr); 
	}
}
@media (min-width: 996px) {
	.products-grid { 
		grid-template-columns: repeat(3, 1fr); 
	}
}

h4 {
	font-size: 16px;
	font-weight: 600;
}
.filter-list {
	display: flex;
	flex-direction: column;
}
.filter-list .filter {
	width: 100%;
	padding: 8px;
	font-size: 15px;
	font-weight: 400;
}
.filter-list .filter:hover {
	background-color: #f3f3f3;
}
.filter-list .filter.selected {
	background-color: #1d1a21;
	color: #ffffff;
}

.filters-bar {
	display: flex;
	align-items: center;
	justify-content: space-around;
	flex-direction: column;
	border-bottom: 1px solid #dddddd;
	padding: 4px 0px;

	.page-title{
		font-size: 18px;
		font-weight: 600;
		padding: 12px 0px;
		text-align: center;
	}
	.filters{
		flex-grow: 1;
		display: flex;
		align-items: center;
		justify-content: end;
		gap: 6px;
	}
}
@media (min-width: 728px) {
	.filters-bar{
		flex-direction: row;
	}
	.page-title{
		padding: 0px;
		text-align: left;
	}
}

.filters-bar .btn {
	padding: 14px;
}
.modal-fullscreen .filter-list .filter {
	padding: 12px 15px;
}

.ui-search-icon {
	width: 14px;
	height: 14px;
	fill: #333333;
}

.pagination-bar{
	justify-items: center;
	padding: 12px 8px;
}
</style>
